import { render, staticRenderFns } from "./viewdetail.vue?vue&type=template&id=49e2cfeb&"
import script from "./viewdetail.vue?vue&type=script&lang=ts&"
export * from "./viewdetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "viewdetail.vue"
export default component.exports